import { EnvironmentConfigPort, Stage } from '../../ports'

export const environmentConfigAdapter: EnvironmentConfigPort = () => {
  let stage: Stage
  if (window.location.hostname.match(/^(www\.)?otto\.de$/)) {
    stage = 'live'
  } else {
    stage = 'nonlive'
  }

  return {
    stage,
  }
}
